/* eslint-disable import/no-mutable-exports */

let configureStore;

if (process.env.APPLICATION_MODE === 'electron') {
    configureStore = require('./configureStoreElectronClient').default;
} else if (process.env.APPLICATION_MODE === 'mobile-hybrid') {
    configureStore = require('./configureStoreMobileHybrid').default;
} else {
    configureStore = require('./configureStoreWeb').default;
}

export default configureStore;
/* eslint-enable import/no-mutable-exports */
